import { action, observable } from 'mobx'

import Ds from './ds'

class Payments {
    @observable paymentDetails = []

    @observable ds = new Ds()

    @action loadPaymentDetails(paymentId) {
        const query = `{ payments(id: ${paymentId}, hash: "${localStorage.getItem('userHash')}") { id orderId qbPaymentNumber qbOrderNumber paymentTypeId amount approvalCode cardNumber, cardType, createdAt} }`
        
        console.log(query)
        
        this.ds.query(query, (data) => {
            this.paymentDetails = data.payments[0]
        })
    }
}

export default new Payments()



// WEBPACK FOOTER //
// ./src/stores/payments.js